import { List } from 'immutable';
import keycode from 'keycode';
import React from 'react';

export interface ISelectStateContext {
  close: (focusWrapper: boolean) => void;
  focusedId: string | undefined;
  focusNext: () => void;
  focusPrevious: () => void;
  focusWrapperTrigger: number;
  isOpen: boolean;
  open: () => void;
  optionIds: List<string>;
  query: string;
  select: (id: string) => void;
  setFocusedId: (id: string) => void;
  setQuery: (query: string) => void;
}

export const SelectStateContext = React.createContext<ISelectStateContext>({
  close: () => {
    throw new Error('close undefined');
  },
  focusedId: '',
  focusNext: () => {
    throw new Error('focusNext undefined');
  },
  focusPrevious: () => {
    throw new Error('focusPrevious undefined');
  },
  focusWrapperTrigger: 0,
  isOpen: false,
  open: () => {
    throw new Error('open undefined');
  },
  optionIds: List(),
  query: '',
  select: () => {
    throw new Error('select undefined');
  },
  setFocusedId: () => {
    throw new Error('setFocusedId undefined');
  },
  setQuery: () => {
    throw new Error('setQuery undefined');
  },
});

export const ESC_KEYCODE = keycode('esc');
export const SPACE_KEYCODE = keycode('space');
export const ENTER_KEYCODE = keycode('enter');
export const UP_KEYCODE = keycode('up');
export const DOWN_KEYCODE = keycode('down');
